module.exports = __webpack_public_path__ + "img/icon_gengduo@2x.428d5aac.png";